/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{create as r}from"../../../../core/libs/gl-matrix-2/factories/mat4f64.js";import t from"../../webgl/RenderCamera.js";class a{constructor(){this.lastFrameCamera=new t,this.matrix=r(),this.viewMatrix=r()}}export{a as ReprojectionUniforms};
